<div class="footer">
    
    <div>
        <p>Version: {{version}}</p>
        <p>@Cignal 2023. All rights reserved.</p>
    </div>

</div>